import type { FC } from 'react';
import {
  TAB_SERIES_ORDER_BY_DESC_HASH,
  TAB_SERIES_ORDER_BY_ASC_HASH,
} from '@app/(default-layout)/se/[seriesId]/_constants';
import { cva } from '@styled-system/css';
import { Box, HStack, type HstackProps } from '@styled-system/jsx';

type Props = {
  currentSelected: TabItem;
  onSelectTab?: (tab: TabItem) => void;
} & HstackProps;

export const TabItem = {
  ORDER_BY_DESC: 'order_by_desc',
  ORDER_BY_ASC: 'order_by_asc',
} as const;
export type TabItem = typeof TabItem[keyof typeof TabItem];

export const OrderTabs: FC<Props> = ({
  currentSelected,
  onSelectTab,
  ...hstackProps
}) => {
  return (
    <HStack
      backgroundColor="surface_secondary"
      h="36px"
      borderRadius="18px"
      w="fit-content"
      {...hstackProps}
    >
      <Box
        id={TAB_SERIES_ORDER_BY_DESC_HASH}
        className={tabStyle({
          selected: currentSelected === TabItem.ORDER_BY_DESC,
        })}
        onClick={() => onSelectTab?.(TabItem.ORDER_BY_DESC)}
      >
        最新話から
      </Box>
      <Box
        id={TAB_SERIES_ORDER_BY_ASC_HASH}
        className={tabStyle({
          selected: currentSelected === TabItem.ORDER_BY_ASC,
        })}
        onClick={() => onSelectTab?.(TabItem.ORDER_BY_ASC)}
      >
        1話から
      </Box>
    </HStack>
  );
};

const tabStyle = cva({
  base: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    height: '100%',
    fontSize: 'size_12',
    px: '3',
    border: '1px solid token(colors.transparent)',
    borderRadius: '17px',
    color: 'content_tertiary',
    cursor: 'pointer',
    transition: 'all 300ms ease',
  },
  variants: {
    selected: {
      true: {
        color: 'content_primary',
        backgroundColor: 'primary',
        fontWeight: 'bold',
        cursor: 'default',
        border: '1px solid token(colors.separator)',
      },
    },
  },
});
